import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import BottomSheet from "@/components/BottomSheet";
import { formatNominalInput, parseNominal, todayYMD } from "@/lib/format";

export default function SetorTabunganForm({
  open,
  onClose,
  onSaved,
  tabunganList = [],
  rekeningList = [],
}) {
  const [tabId, setTabId] = useState(tabunganList[0]?.id || "");
  const [tanggal, setTanggal] = useState(todayYMD());
  const [nominal, setNominal] = useState("");
  const [rekeningId, setRekeningId] = useState(rekeningList[0]?.id || "");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) {
      setTabId(tabunganList[0]?.id || "");
      setTanggal(todayYMD());
      setNominal("");
      setRekeningId(rekeningList[0]?.id || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    const n = parseNominal(nominal);
    if (!tabId) return toast.error("Pilih goal");
    if (!rekeningId) return toast.error("Pilih rekening");
    if (n <= 0) return toast.error("Jumlah setor harus > 0");

    setBusy(true);
    try {
      await api.post(`/tabungan/${tabId}/setor`, {
        tanggal,
        nominal: n,
        rekening_id: rekeningId,
      });
      toast.success("Setoran tabungan tercatat");
      onClose();
      onSaved && onSaved();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      title="Setor Tabungan"
      testId="setor-tabungan-sheet"
    >
      <form onSubmit={submit} className="space-y-4" data-testid="setor-tabungan-form">
        <Field label="Pilih goal">
          <select
            value={tabId}
            onChange={(e) => setTabId(e.target.value)}
            data-testid="setor-tabungan-select"
            className={inputCls}
            required
          >
            <option value="">— Pilih goal —</option>
            {tabunganList.map((t) => (
              <option key={t.id} value={t.id}>
                {t.nama}
              </option>
            ))}
          </select>
        </Field>
        <Field label="Tanggal">
          <input
            type="date"
            value={tanggal}
            onChange={(e) => setTanggal(e.target.value)}
            data-testid="setor-tabungan-tanggal"
            className={inputCls}
            required
          />
        </Field>
        <Field label="Jumlah setor (Rp)">
          <input
            type="text"
            inputMode="numeric"
            value={nominal}
            onChange={(e) => setNominal(formatNominalInput(e.target.value))}
            data-testid="setor-tabungan-nominal"
            className={inputCls}
            required
          />
        </Field>
        <Field label="Dari rekening">
          <select
            value={rekeningId}
            onChange={(e) => setRekeningId(e.target.value)}
            data-testid="setor-tabungan-rekening"
            className={inputCls}
            required
          >
            <option value="">— Pilih rekening —</option>
            {rekeningList.map((r) => (
              <option key={r.id} value={r.id}>
                {r.nama} ({r.bank})
              </option>
            ))}
          </select>
        </Field>

        {tabunganList.length === 0 && (
          <div className="text-xs text-slate-500 bg-slate-50 border border-slate-100 rounded-lg p-3">
            Belum ada goal. Buat goal dulu sebelum menyetor.
          </div>
        )}

        <button
          type="submit"
          disabled={busy || tabunganList.length === 0}
          data-testid="setor-tabungan-submit"
          className="w-full h-11 rounded-xl font-semibold text-sm text-white tap disabled:opacity-60"
          style={{ backgroundColor: "#1F4E5F" }}
        >
          {busy ? "Menyimpan..." : "Setor"}
        </button>
      </form>
    </BottomSheet>
  );
}

const inputCls =
  "mt-1 w-full h-11 px-3 rounded-xl border border-slate-200 focus:border-[#1F4E5F] focus:outline-none text-sm bg-white";

function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-xs font-semibold text-slate-600">{label}</span>
      {children}
    </label>
  );
}
